// eslint-disable-next-line react/display-name,react/prop-types
export default function wrapWithProvider({ element }) {
  return element;
}
